const generateUniqueId = (length = 10) => {
  const timestamp = Date.now().toString(36);
  const randomChars = Math.random().toString(36).substr(2, length);
  const uniqueId = timestamp + randomChars;

  return uniqueId;
};

const removeSubOptions = (id, formConfig) => {
  if (formConfig?.conditions?.length) {
    return formConfig.conditions.filter((item) => item?.choice !== id);
  }

  return [];
};

const filterValidOptions = (options, valueKey = 'value') => {
  return (options || []).filter((item) => !!item?.[valueKey]?.trim() || item?.others);
};

const getSanitizedConfig = (config) => {
  let updatedConfig = { ...config };
  if (config?.options?.length) {
    updatedConfig.options = filterValidOptions(config.options);
  }

  if (updatedConfig?.conditions?.length) {
    updatedConfig.conditions = filterValidOptions(updatedConfig.conditions, 'choice');

    updatedConfig.conditions = updatedConfig.conditions.filter((option) => {
      if (
        !!option?.choice?.trim()
        && !!option?.config?.label?.trim()
        && option?.config?.type
        && (option?.config?.options?.length ? filterValidOptions(option.config.options).length : true)
      ) return true;

      return false;
    }).map((item) => ({
      ...item,
      config: {
        ...item?.config,
        ...(item?.config?.options?.length && ({
          options: filterValidOptions(item.config.options),
        })),
      },
    }));
  }

  if (updatedConfig?.specificTicketType && !updatedConfig?.ticketTypes?.length) {
    updatedConfig.specificTicketType = false;
  }

  return updatedConfig;
};

export {
  generateUniqueId,
  removeSubOptions,
  filterValidOptions,
  getSanitizedConfig,
};